import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageTab from 'shared/components/page-tab/page-tab';
import Routes from 'shared/enums/routes';

const ResidentsNavigation: React.FC = () => {
  const { t } = useTranslation('residents');
  const navigate = useNavigate();

  return (
    <PageTab
      onPageChanged={(link: string) => navigate(link)}
      mainRoute={Routes.Residents}
      pageTabs={[
        {
          subRoute: Routes.ResidentsSettings,
          title: t('pageTab.settingsLabel'),
        },
        {
          subRoute: Routes.ResidentsChangeLog,
          title: t('pageTab.changeLogLabel'),
        },
      ]}
    />
  );
};

export default ResidentsNavigation;
